function getTitleStrings (matches, queries) {
  const icpRequirements = matches?.search_gen_response?.icp_requirements || []
  const queryDict = queries || {} // Assuming queries is a dictionary
  let roles = []

  icpRequirements.forEach(req => {
    if (req.section_name === 'Current Role') {
      let bool_str = req.bool_str

      // Remove brackets from the bool_str
      bool_str = bool_str.replace(/[()]/g, '')

      let ors = bool_str.split('OR')
      ors.forEach(orval => {
        let orval_buckets = orval.split(':')

        if (orval_buckets.length === 2) {
          // If the format is key:value, take the value and process it
          roles.push(orval_buckets[1].toLowerCase().trim())
        } else {
          const key = orval_buckets[0].trim()
          const queryValue = queryDict[key]

          if (queryValue && queryValue.name) {
            // If the key exists in queryDict and has a name field
            roles.push(queryValue.name.toLowerCase())
          } else {
            // Fallback: Push the key itself as a lowercase string
            roles.push(key.toLowerCase())
          }
        }
      })
    }
  })

  // Remove duplicates from roles
  roles = [...new Set(roles)]

  return roles
}

module.exports = { getTitleStrings };
